function HardwareInfo() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Unit.HardwareInfo Visual. <br/>
    /// basically just calls the get data from the visual and sets the clocktimer
    /// Uses the load type 3 === UNIT table loading
    /// <br/>
    /// Author: MWI<br />
    /// Date: 14.03.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 14.03.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>  
};
HardwareInfo.prototype = new vcTemplate();

HardwareInfo.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// it adds the clickhandler, the filter and the caleander <br/>
    /// further, it loads the initial content
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
        window.VisualCoreService.getDataByName("VISUAL_UNIT_SYSTEMOVERVIEW", '1', getCurrentTimestamp(), me.visual.width(), me.visual.height(), "", "", 1, JSON.stringify({ "type": 4, "hardwareid": me.luhid }), function (result) {
            me.visual.html(result);
            me.visual.find(".clock").vcClockTimer({ width: "500px" });
            me.visual.find('.cl').off('click');
            me.visual.find(".tecDet").toggle(me.tecDet);
            me.visual.find('.fileView').unbind('click').click(function () {
                showModalPopup("<div id='divMediaPopup1' class='frame' ></div>", 700, 394);
                var media = {
                    mediaid: $(this).attr('data-id'),
                    height: 374,
                    width: 680,
                    pos: 'right',
                    show: true
                };
                me.vcVisual.addVisualContentByName('divMedia', 'VISUAL_FILEVIEWER', 'Popup1', getCurrentTimestamp(), 374, 680, JSON.stringify(media), '', 2);
            });
        });

        return true;
    } catch (ex) {
        me.writeError("HardwareInfo.init", ex);
        return false;
    }
};

//#END REGION FILTER